import SelfControlCard from "../../molecules/selfcontrolcard/SelfControlCard";
import YesOrNoCheckbox from "../../molecules/yesornocheckbox/YesOrNoCheckbox";
import LabelAndTextBox from "../../molecules/labelandtextbox/LabelAndTextBox";
import { SelfControlContainerModel } from '../../../api';
import "./SelfControlContainer.css";

interface SelfControlContainerProp {
  projectId: number;
  selfControlContainer: SelfControlContainerModel,
  setSelfControlContainer?: React.Dispatch<React.SetStateAction<SelfControlContainerModel | undefined>>;
  onUpdate: () => void
}
const SelfControlContainer: React.FC<SelfControlContainerProp> = (props) => {

  const handleChange = (updatedData: Partial<SelfControlContainerModel>) => {
    const newObject = { ...props.selfControlContainer, ...updatedData };
    props.setSelfControlContainer?.(newObject);
    props.onUpdate();
  };

  const handleItemChange = (index: number, updatedItem: any) => {
    const newItems = [...(props.selfControlContainer.selfControlItems ?? [])];
    newItems[index] = { ...newItems[index], ...updatedItem };
    handleChange({ selfControlItems: newItems });
  };

  return (
    <div>
      {(props.selfControlContainer?.selfControlItems ?? []).map((item: any, index: number) => (
        <SelfControlCard
          key={`selfControlContainer${index}`}
          selfControlItem={item}
          projectId={props.projectId}
          onUpdate={(updatedItem) => handleItemChange(index, updatedItem)}
        />
      ))}
      <div className="horizontal-checkboxes">
        <div className="mt-4" />
        <YesOrNoCheckbox
          approved={props.selfControlContainer?.samplingProtocolAttached}
          onChange={(value) => handleChange({ samplingProtocolAttached: value })}
          radioGroup="provdragningsProtokollBifogas"
          useCheckboxModel
          title="Provdragningsprotokoll bifogas" />
        <div className="workplaceclean mt-4 mb-4">
          <YesOrNoCheckbox
            approved={props.selfControlContainer?.workplaceCleaned}
            onChange={(value) => handleChange({ workplaceCleaned: value })}
            radioGroup="arbetsPlatsStädad"
            useCheckboxModel
            title="ARBETSPLATS STÄDAD" />
        </div>
      </div>
      <LabelAndTextBox
        remark={props.selfControlContainer?.otherThingsToNote}
        onChange={(value) => handleChange({ otherThingsToNote: value })}
        title="ÖVRIGT ATT NOTERA" />
    </div>
  )
}

export default SelfControlContainer;